import { OrderDetailPage, Remark } from "@careinfo/layout";
import {
  AccessControl,
  ClientAccessControl,
} from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import { useSessionStorage } from "@uidotdev/usehooks";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import TrashIcon from "../../Icons/TrashIcon";
import { queryClient } from "../../router/ConsignmentRouter";
import { classNames } from "../../utils/classNames";
import { hasValues } from "../../utils/hasValues";
import DeliveryPartnerMenu from "../DeliveryPartnerMenu";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import DataTable from "../Reusable/DataTable";
import Modal from "../Reusable/Modal";
import TableActionButton from "../Reusable/TableActionButton";
import OrderFilter from "./ConsignmentFilter";
import OrderMenu from "./ConsignmentMenu";
import DownloadActionMenu from "./DownloadActionMenu";
import EditDeliveryCharge from "./EditDeliveryCharge";
import OrderActionMenu from "./OrderActionMenu";
import ScanQrCode from "./ScanQrCode";
import Suborders from "./Suborders";
import OperationCombobox from "../Reusable/OpeationCombobox";
import DeliveryForm from "../Reusable/DeliveryForm";
import TabPanel from "../Reusable/Tab";

interface IDeliveryStatusIn {
  id: string;
  label: string;
  name: string;
  value: string;
}

export interface IFilter {
  is_rtv: string | null;
  order_remarks__isnull: string | null;
  is_walking_customer: string | null;
  delivery_status__in: IDeliveryStatusIn[] | null;
  pickup_branch: string | null;
  destination__in?: string | null;
  payment_method: string | null;
  pickup_branch__warehouse: string | null;
  destination_branch__warehouse: string | null;
  destination: string | null;
  vendor: string | null;
  created__range: string | null;
  sender: string | null;
  receiver: string | null;
  assign_order: string | null;
  staff: string | null;
  operations: string | null;
  comment: string | null;
}

const ConsignmentList = ({
  handleDelete,
  isLoading,
  openDeletePopup,
  setOpenDeletePopup,
  commentMethods,
  resetComment,
  status,
}: any) => {
  const [searchParams, setSearchParms] = useSearchParams();
  const [localState, handleSetState] = useSessionStorage<IFilter>(
    "consignment-filter",
    {
      is_rtv: null,
      order_remarks__isnull: null,
      is_walking_customer: null,
      delivery_status__in: null,
      pickup_branch: null,
      payment_method: null,
      pickup_branch__warehouse: null,
      destination_branch__warehouse: null,
      vendor: null,
      created__range: null,
      destination: null,
      sender: null,
      receiver: null,
      assign_order: null,
      destination__in: null,
      staff: null,
      operations: null,
      comment: null,
    }
  );
  const {
    register,
    setValue,
    getValues,
    watch,
    setError,
    reset,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<IFilter>({
    defaultValues: async () => ({
      is_rtv: localState?.is_rtv ?? null,
      order_remarks__isnull: localState?.order_remarks__isnull ?? null,
      is_walking_customer: localState?.is_walking_customer ?? null,
      delivery_status__in: null,
      // delivery_status__in: [
      //   {
      //     id: "918b8bf2-cc0a-4c43-be9c-c864f3416808",
      //     label: "Pending Dispatch",
      //     name: "Pending Dispatch",
      //     value: "918b8bf2-cc0a-4c43-be9c-c864f3416808",
      //   },
      // ],
      pickup_branch: localState?.pickup_branch ?? null,
      payment_method: localState?.payment_method ?? null,
      pickup_branch__warehouse: localState?.pickup_branch__warehouse ?? null,
      destination_branch__warehouse:
        localState?.destination_branch__warehouse ?? null,
      vendor: localState?.vendor ?? null,
      created__range: localState?.created__range ?? null,
      sender: localState?.sender ?? null,
      receiver: localState?.receiver ?? null,
      destination: localState?.destination ?? null,
      assign_order: localState?.assign_order ?? null,
      staff: localState?.staff ?? null,
      operations: localState?.operations ?? null,
      destination__in: localState?.destination__in ?? null,
      comment: null,
    }),
  });
  const [isFilterVisible, setFilterVisiable] = useState(hasValues(localState));
  const [chargevalue, setChargeValue] = useState();
  const [orderActionMenu, setOrderActionMenu] = useState(false);
  const [actionType, setActionType] = useState("");
  const [openReviewModal, setOpenReviewModal] = useState(false);
  const [openorderhistoryPopup, setOpenOrderHistoryPopup] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState("");
  const [openDeliveryModal, setOpenDeliveryModal] = useState(false);
  const [openSuborderpopup, setOpensuborderPopup] = useState(false);
  const [rowid, setRowid] = useState();
  const [isactive, setISactive] = useState("trackbutton");
  const [deleteOrder, setDeleteOrder] = useState();
  const [openDeliveryformPopup, setOpenDeliveryformPopup] = useState(false);
  // const [deliveryStatus, setDeliveryStatus] = useState(false);

  const operationData = [
    { id: "Pickup (Receive)", name: "Pickup (Receive)" },
    { id: "Manifest (Receive)", name: "Manifest (Receive)" },
    { id: "Delivery", name: "Delivery" },
  ];

  const handleFilterReset = () => {
    reset({
      is_rtv: null,
      order_remarks__isnull: null,
      is_walking_customer: null,
      delivery_status__in: null,
      pickup_branch: null,
      payment_method: null,
      pickup_branch__warehouse: null,
      destination_branch__warehouse: null,
      destination__in: null,
      vendor: null,
      created__range: null,
      sender: null,
      receiver: null,
      assign_order: null,
      staff: null,
      operations: null,
    });
  };

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["order"],
    navigateURL: "",
  });
  const { data: deliveryPartnerData } = useGetHook({
    url: APIS.DELIVERY_PARTNER,
    queryKey: ["delivery-partner"],
    params: {
      is_active: true,
    },
  });

  const checkedAllItems = searchParams.get("selectAllItems") === "1";
  const selectedOrderDetails = searchParams.get("selectedItem");
  const location = useLocation();
  const navigate = useNavigate();

  const appendSelectedItem = useCallback(
    (selectedItem: any) => {
      const params = new URLSearchParams(location.search);
      params.set("selectedItem", selectedItem);

      const newFullPath = `${location.pathname}?${params.toString()}`;

      navigate(newFullPath, { replace: true });
    },
    [location.pathname, location.search, navigate]
  );

  const handleIndividualSelect = useCallback(
    (value: string) => {
      let selectedItems = searchParams.get("selectedItems")?.split(",");
      if (!selectedItems || selectedItems === undefined) {
        searchParams.set("selectedItems", value);
        setSearchParms(searchParams);
        return;
      }
      let itemIndex = selectedItems?.findIndex((item) => item === value);
      if (itemIndex > -1) {
        selectedItems.splice(itemIndex, 1);
        const newSelectedItems = selectedItems
          ?.map((item) => item)
          .join(",")
          .toString();
        if (newSelectedItems.length) {
          searchParams.set("selectedItems", newSelectedItems);
        } else {
          searchParams.delete("selectedItems");
        }
        searchParams.set("selectAllItems", "0");
        setSearchParms(searchParams);
      } else {
        selectedItems?.push(value);
        const newSelectedItems = selectedItems
          ?.map((item) => item)
          .join(",")
          .toString();
        searchParams.set("selectedItems", newSelectedItems);
        setSearchParms(searchParams);
      }
    },
    [searchParams, setSearchParms]
  );
  const { data: tableConfigData, isLoading: isTableConfigLoading } = useGetHook(
    {
      url: `${APIS.TABLE_CONFIG}${"order"}/`,
      queryKey: ["order"],
      params: {},
    }
  );
  const isSelected = useCallback(
    (value: string) => {
      const selectedItems = searchParams.get("selectedItems")?.split(",");
      if (!selectedItems) {
        return false;
      }
      return selectedItems.includes(value);
    },
    [searchParams]
  );

  const handleSelectAll = useCallback(
    (table: any) => {
      const {
        options: { data: tableData },
      } = table;
      const isSelected = searchParams.get("selectAllItems");
      if (isSelected === "1") {
        searchParams.set("selectAllItems", "0");
        searchParams.delete("selectedItems");
        setSearchParms(searchParams);
      } else {
        const selectedItems = tableData
          ?.map((item: any) => item.id)
          .join(",")
          .toString();
        searchParams.set("selectAllItems", "1");
        searchParams.set("selectedItems", selectedItems);
        setSearchParms(searchParams);
      }
    },
    [searchParams, setSearchParms]
  );

  const defaultColumns = useMemo(
    (): ColumnDef<any, any>[] => [
      {
        id: "select",
        header: ({ table }: any) => {
          return (
            <input
              type="checkbox"
              checked={checkedAllItems}
              onChange={() => handleSelectAll(table)}
              className={tw`cursor-pointer`}
            />
          );
        },
        cell: ({ row }: any) => (
          <input
            type="checkbox"
            checked={isSelected(row?.original?.id)}
            onChange={() => handleIndividualSelect(row?.original?.id)}
            className={tw`cursor-pointer`}
          />
        ),
      },
      {
        header: "WayBill",
        accessorKey: "tracking_number",
        cell: ({ row, getValue }: any) => {
          return (
            <button
              onClick={() => {
                appendSelectedItem(row?.original?.id);
              }}
              className={tw`cursor-pointer focus:outline-none px-4 relative`}
            >
              <ClientAccessControl
                children={
                  <p className={tw`whitespace-nowrap text-center`}>
                    {getValue() ?? "N/A"}
                  </p>
                }
                allowedPermissions={["can_view_tracking"]}
              />
              <ClientAccessControl allowedPermissions={["can_view_order_id"]}>
                <p
                  className={tw`text-xs text-gray-500 text-center whitespace-nowrap`}
                >
                  {row?.original?.order_number}
                </p>
              </ClientAccessControl>
              <ClientAccessControl
                children={
                  <p
                    className={tw`text-xs text-gray-500 uppercase text-center`}
                  >
                    {row?.original?.service_type?.name}
                  </p>
                }
                allowedPermissions={["can_view_service_type"]}
              />
              {row?.original?.is_on_hold && (
                <span
                  className={tw` absolute -top-2 text-[10px] -right-5 text-white px-[4px] bg-red-400 rounded-full `}
                >
                  H
                </span>
              )}
              {row?.original?.is_pickup_created && (
                <span
                  className={tw` absolute -top-2 text-[10px] -right-1 text-white px-[4px] bg-red-400 rounded-full `}
                >
                  P
                </span>
              )}
            </button>
          );
        },
      },
      {
        header: "Date",
        accessorKey: "created",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              {getValue() ? (
                <p className={tw`whitespace-nowrap`}>
                  {moment(getValue()).format("YY-MM-DD HH:mm:ss")}
                </p>
              ) : (
                "N/A"
              )}
            </>
          );
        },
      },
      {
        header: "Origin",
        accessorKey: "pickup_branch.name",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <p className={tw`uppercase`}>{getValue()}</p>
              <p className={tw`text-xs text-primary`}>
                {row?.original?.pickup_branch?.warehouse?.name}
              </p>
            </>
          );
        },
      },
      {
        header: "Sender",
        accessorKey: "sender.full_name",
        cell: ({ row }: any) => {
          return (
            <>
              <ClientAccessControl
                children={
                  <p className={tw``}>
                    {row?.original?.sender?.full_name ?? "N/A"}{" "}
                  </p>
                }
                allowedPermissions={["can_view_sender_name"]}
              />
              <ClientAccessControl
                children={
                  <p className={tw`whitespace-nowrap text-sm`}>
                    {row?.original?.sender?.primary_contact ?? "N/A"}{" "}
                  </p>
                }
                allowedPermissions={["can_view_sender_number"]}
              />
            </>
          );
        },
      },
      {
        header: "Receiver",
        accessorKey: "receiver.full_name",
        cell: ({ row }: any) => {
          return (
            <>
              <ClientAccessControl
                children={
                  <p className={tw``}>
                    {row?.original?.receiver.full_name ?? "N/A"}{" "}
                  </p>
                }
                allowedPermissions={["can_view_receiver_name"]}
              />
              <ClientAccessControl
                children={
                  <p className={tw`whitespace-nowrap text-sm`}>
                    {row?.original?.receiver.primary_contact ?? "N/A"}{" "}
                  </p>
                }
                allowedPermissions={["can_view_receiver_number"]}
              />
              <ClientAccessControl
                children={
                  <p className={tw`text-sm`}>
                    {row?.original?.receiver.address ?? "N/A"}{" "}
                  </p>
                }
                allowedPermissions={["can_view_receiver_location"]}
              />
            </>
          );
        },
      },
      {
        header: "Destination",
        accessorKey: "destination.name",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <p className={tw`uppercase`}>{getValue()}</p>
              <p className={tw`text-xs text-primary`}>
                {row?.original?.destination_branch?.warehouse?.name}
              </p>
            </>
          );
        },
      },

      {
        header: "Piece",
        accessorKey: "piece",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <ClientAccessControl allowedPermissions={["can_view_piece"]}>
                <button
                  className={tw`cursor-pointerb focus:outline-none`}
                  onClick={() => {
                    setOpensuborderPopup(!openSuborderpopup);
                    setRowid(row?.original?.id);
                  }}
                >
                  {getValue() ?? 0.0}
                </button>
              </ClientAccessControl>
            </>
          );
        },
      },
      {
        header: "Remarks",
        accessorKey: "remark",
        cell: ({ row, getValue }: any) => (
          <>
            <ClientAccessControl
              children={
                <button
                  className={tw`focus:outline-none`}
                  onClick={() => {
                    setSelectedOrder(row?.original?.id);
                    setOpenReviewModal(true);
                  }}
                >
                  {getValue()} Remarks
                </button>
              }
              allowedPermissions={["can_view_remarks"]}
              renderNoAccess={<p>{getValue()} Remarks</p>}
            />
          </>
        ),
      },
      {
        header: "Status",
        accessorKey: "delivery_status.name",
        cell: ({ row, getValue }: any) => {
          return (
            <>
              <ClientAccessControl
                children={
                  <>
                    <p
                      className={tw`uppercase px-1 text-center rounded-md`}
                      style={{
                        background: row?.original?.delivery_status?.color,
                      }}
                    >
                      {getValue()}
                    </p>
                    <p className={tw`text-xs text-primary `}>
                      {row?.original?.rider?.name}
                    </p>
                  </>
                }
                allowedPermissions={["can_view_status"]}
              />
            </>
          );
        },
      },
      {
        header: "Action",
        accessorKey: "id",
        cell: ({ row, getValue }: any) => (
          <div
            className="grid"
            style={{
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "1em",
              height: "100%",
              placeItems: "center",
            }}
          >
            <AccessControl
              allowedPermissions={[
                "can_editupdate_consignment",
                "can_partial_edit_order",
              ]}
            >
              <div>
                <TableActionButton editPath={`edit/${getValue()}`} />
              </div>
            </AccessControl>
            <AccessControl allowedPermissions={["can_view_order_delete"]}>
              <button
                type="button"
                disabled={isLoading || false}
                onClick={() => {
                  setDeleteOrder(row?.original.id);
                  setOpenDeletePopup(!openDeletePopup);
                }}
                className="focus:outline-none"
              >
                <TrashIcon color={"var(--primary)"} />
              </button>
            </AccessControl>
          </div>
        ),
      },
    ],
    [
      appendSelectedItem,
      handleIndividualSelect,
      checkedAllItems,
      handleSelectAll,
      isLoading,
      isSelected,
      openDeletePopup,
      openSuborderpopup,
      setOpenDeletePopup,
    ]
  );
  const handleactiveButton = (button) => {
    setISactive(button);
  };

  const handleHoldOrder = async (selectedOrder: any, setError: any) => {
    const url = `${APIS.ORDER}hold/`;
    let formData = {
      order_ids: selectedOrder,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false);
        queryClient.refetchQueries();
      }
    } catch (err) {
      toast.success("Somethings went wrong");
    }
  };

  const { data: deliveryStatus, isLoading: isDeliveryStatusLoading } =
    useGetHook({
      queryKey: ["delivery-setting"],
      url: APIS.DELIVERY_STATUS,
      params: {
        status: "final",
      },
    });

  const finalStatusIds = deliveryStatus?.find(
    (item) => item.status === "final"
  )?.status_id;

  const handleStatusUpdate = async (
    selectedOrder: any,
    data: any,
    setError: any
  ) => {
    const url = `${APIS.ORDER}change-status/`;
    let formData = {
      order_ids: selectedOrder,
      status: data?.status,
      remark: data?.remark,
      collected_cod: data?.collected_cod,
    };
    if (data?.status === finalStatusIds?.[0]?.id) {
      if (selectedOrder.length > 1) {
        toast.error("Please select one order first");
        return;
      }
      setOrderActionMenu(false);
      setOpenDeliveryformPopup(true);
      return;
    }
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 200) {
        setOrderActionMenu(false);
        queryClient.invalidateQueries({
          refetchType: "active",
        });
        if (!tableConfigData?.preserve_select) {
          searchParams.delete("selectedItems");
          setSearchParms(searchParams);
        }
      }
    } catch (err) {
      toast.success("Somethings went wrong");
    }
  };

  const handleActionMenu = (
    data: any,
    status: any,
    type: string,
    setError: any
  ) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder) {
      toast.error("Please select one order first");
      setOrderActionMenu(false);
      return;
    }
    if (type === "Change Status") {
      // setOpenDeliveryformPopup(true);
      // setOrderActionMenu(false);
      handleStatusUpdate(selectedOrder, data, setError);
      // setDeliveryStatus(status?.id);
    } else if (type === "Hold/Release") {
      handleHoldOrder(selectedOrder, setError);
    }
  };

  const filterParams = watch();

  useEffect(() => {
    if (selectedOrderDetails) {
      setOpenOrderHistoryPopup(true);
    } else {
      setOpenOrderHistoryPopup(false);
    }
  }, [selectedOrderDetails]);

  const handleClosePopup = () => {
    setOpenOrderHistoryPopup(false);
    setTimeout(() => {
      const params = new URLSearchParams(location.search);
      params.delete("selectedItem");
      const newFullPath = `${location.pathname}?${params.toString()}`;
      navigate(newFullPath, { replace: true });
    }, 300);
  };

  const handleDeleteModalClose = () => {
    setOpenDeletePopup(!openDeletePopup);
    clearErrors("comment");
    resetComment();
  };

  useEffect(() => {
    handleSetState({
      ...localState,
      ...filterParams,
      delivery_status__in: filterParams?.delivery_status__in
        ? filterParams.delivery_status__in.map((d) => ({
            id: d.value,
            name: d.label,
            label: d.label,
            value: d.value,
          }))
        : localState?.delivery_status__in,
    });
  }, [filterParams]);

  const operations = filterParams["operations"];

  const filters = useCallback(() => {
    const newValue = {};
    for (const [key, value] of Object.entries(filterParams)) {
      if (value) {
        if (Array.isArray(value)) {
          newValue[key] = value.map((v) => v.value).join(",");
        } else if (typeof value === "object") {
          newValue[key] = value.id;
        } else if (!value) {
          newValue[key] = null;
        } else {
          newValue[key] = value;
        }
      }
    }
    return newValue;
  }, [filterParams]);

  return (
    <>
      <AccessControl
        children={
          <Card
            title="Filters"
            onClick={() => setFilterVisiable(!isFilterVisible)}
          >
            <OrderFilter
              isFilterVisible={isFilterVisible}
              register={register}
              errors={errors}
              setValue={setValue}
              getValues={getValues}
              reset={handleFilterReset}
              watch={watch}
              clearErrors={clearErrors}
              //@ts-ignore
              control={control}
            />
          </Card>
        }
        allowedPermissions={["can_edit_filter"]}
      />
      <DataTable
        url={APIS.ORDER}
        queryKey={"orders"}
        columns={defaultColumns}
        addNewPagePath={"/create"}
        tableName={"consignments-table"}
        isUpload={false}
        isDownload={true}
        params={{ ...filters() }}
        actionMenu={
          <div className={tw`flex w-full whitespace-nowrap items-center`}>
            <div className={tw`flex  border mr-2  rounded-full`}>
              <button
                onClick={() => handleactiveButton("trackbutton")}
                className={classNames(
                  isactive === "trackbutton"
                    ? tw`bg-primary text-white px-3`
                    : tw``,
                  tw`focus:outline-none px-2 py-2 rounded-full`
                )}
              >
                Tracking ID
              </button>
              <button
                onClick={() => handleactiveButton("referencebutton")}
                className={classNames(
                  isactive === "referencebutton"
                    ? tw`bg-primary text-white  px-3`
                    : tw``,
                  tw`focus:outline-none px-2 rounded-full  py-2`
                )}
              >
                Reference ID
              </button>
            </div>
            <div className={tw`w-72 relative -top-2 text-black`}>
              <OperationCombobox
                data={operationData}
                register={register("operations")}
                errors={errors?.operations}
                name={"operations"}
                setValue={setValue}
                placeholder={"Select"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
            <AccessControl
              children={
                <ScanQrCode
                  operations={operations}
                  isactive={isactive}
                  setValue={setValue}
                  setError={setError}
                  clearErrors={clearErrors}
                  setOpenDeliveryformPopup={setOpenDeliveryformPopup}
                />
              }
              allowedPermissions={["can_scan_barcode"]}
            />

            <AccessControl allowedPermissions={["can_perform_action"]}>
              <OrderMenu
                orderActionMenu={orderActionMenu}
                setOrderActionMenu={setOrderActionMenu}
                setActionType={setActionType}
              />
            </AccessControl>
            <AccessControl allowedPermissions={["can_assign_delivery_partner"]}>
              <DeliveryPartnerMenu data={deliveryPartnerData} />
            </AccessControl>
            <AccessControl allowedPermissions={["can_download"]}>
              <DownloadActionMenu isDownload={true} queryKey={"order"} />
            </AccessControl>
          </div>
        }
      />
      <Modal
        isOpen={orderActionMenu}
        setIsOpen={setOrderActionMenu}
        title={actionType}
      >
        <OrderActionMenu
          handleActionMenu={handleActionMenu}
          setOrderActionMenu={setOrderActionMenu}
          actionType={actionType}
          isLoading={isPostLoading}
        />
      </Modal>
      <Modal
        title={"Update Delivery Charge"}
        isOpen={openDeliveryModal}
        setIsOpen={setOpenDeliveryModal}
      >
        <div className={tw`w-[500px]`}>
          <EditDeliveryCharge
            openDeliveryModal={openDeliveryModal}
            setOpenDeliveryModal={setOpenDeliveryModal}
            chargevalue={chargevalue}
          />
        </div>
      </Modal>
      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
      >
        <div className={tw`w-[600px]`}>
          <Remark selectedOrder={selectedOrder} />
        </div>
      </Modal>
      <Modal
        isOpen={openorderhistoryPopup}
        title={"Order Detail"}
        setIsOpen={handleClosePopup}
      >
        <OrderDetailPage selectedOrder={selectedOrderDetails} />
      </Modal>
      <Modal
        isOpen={openDeletePopup}
        setIsOpen={handleDeleteModalClose}
        title={""}
      >
        <>
          <div className={tw`flex flex-col justify-center items-center  h-fit`}>
            <p className={tw`text-lg font-semibold mb-4`}>
              Are you sure you want to delete ?
            </p>
            <form
              className={tw`flex flex-col gap-y-2`}
              autoComplete="off"
              onSubmit={commentMethods.handleSubmit((data: any) =>
                handleDelete(data, deleteOrder, setError, clearErrors)
              )}
            >
              <textarea
                {...commentMethods.register("comment")}
                placeholder="Write a reason for delete..."
                rows={5}
                className={tw`border px-2 py-2 w-96 focus:outline-none`}
              ></textarea>
              {commentMethods.formState.errors?.comment && (
                <p className={tw`text-red-500 text-xs my-1`}>
                  {commentMethods.formState.errors?.comment?.message}
                </p>
              )}
              <div
                className={tw`mt-6 flex justify-center gap-x-6 items-center`}
              >
                <div className={tw`w-24`}>
                  <Button
                    label={"Yes"}
                    isLoading={isLoading}
                    // onClick={() => handleDelete(deleteOrder, setError)}
                  />
                </div>
                <div>
                  <button
                    type="button"
                    className={tw`w-full px-[24px] py-2 rounded  focus:outline-none bg-[#EEF5F4]`}
                    onClick={handleDeleteModalClose}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </>
      </Modal>
      <Modal
        isOpen={openDeliveryformPopup}
        setIsOpen={() => {
          searchParams.delete("selectedWayBillNumber");
          setSearchParms(searchParams);
          setOpenDeliveryformPopup(false);
        }}
        title={"Receiver Details"}
      >
        <div className={tw`w-[600px]`}>
          <DeliveryForm
            setIsOpen={setOpenDeliveryformPopup}
            deliveredStatus={finalStatusIds?.[0]}
          />
        </div>
      </Modal>
      <Modal
        isOpen={openSuborderpopup}
        setIsOpen={setOpensuborderPopup}
        title={"Sub Orders"}
      >
        <div className={tw`w-[600px] `}>
          <Suborders id={rowid} />
        </div>
      </Modal>
    </>
  );
};

export default ConsignmentList;
